import { uiText } from "@/lib/i18n/uiText";
import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { InstallAppButton, useInstallAvailability } from "@/components/pwa/InstallAppButton";

const DISMISS_KEY = "statlign-install-dismissed";
const VISITS_KEY = "statlign-visits";

/** Second-visit reminder card. The main entry point is the Install button in the menu. */
export function InstallAppPrompt() {
  const { available } = useInstallAvailability();
  const [eligible, setEligible] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(VISITS_KEY)) return setEligible(Number(localStorage.getItem(VISITS_KEY) || 0) >= 2 && !recentlyDismissed());
    const visits = Number(localStorage.getItem(VISITS_KEY) || 0) + 1;
    localStorage.setItem(VISITS_KEY, String(visits));
    sessionStorage.setItem(VISITS_KEY, "1");
    if (visits < 2 || recentlyDismissed()) return;
    const t = window.setTimeout(() => setEligible(true), 0);
    return () => clearTimeout(t);
  }, []);

  if (!available || !eligible) return null;
  const close = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setEligible(false);
  };
  return (
    <div role="dialog" aria-label={uiText("Install Statlign")} className="fixed inset-x-3 bottom-20 md:bottom-4 md:left-auto md:right-4 md:w-96 z-40 rounded-xl border border-border bg-card p-4 shadow-lg">
      <button onClick={close} aria-label={uiText("Dismiss")} className="absolute right-2 top-2 p-2 text-muted-foreground hover:text-foreground">
        <X className="h-4 w-4" />
      </button>
      <p className="font-semibold text-sm pr-6">{uiText("Get Statlign on your home screen")}</p>
      <p className="text-xs text-muted-foreground mt-1">{uiText("One-tap access to today's picks, high odds and results — full screen, no browser bar.")}</p>
      <div className="mt-3">
        <InstallAppButton variant="default" label={uiText("Install app")} className="min-h-11" />
      </div>
    </div>
  );
}

function recentlyDismissed() {
  return Date.now() - Number(localStorage.getItem(DISMISS_KEY) || 0) < 14 * 864e5;
}
